import React from 'react';
import { useTranslation } from 'react-i18next';

import {
  Form,
  ButtonsWrapper,
  Button,
  TextInput,
  NumberInput,
} from '@thinknet-gmbh/platform-common-ui';

import { ClientsSelect } from '../clients-select/';

import { ISalaryTypesTableValues } from '../../salary-types-interfaces';

const SalaryTypesForm = ({
  onClose,
  onFinishHandler,
  initialValues,
  loading,
  isEdit,
  datevNumbers,
}: {
  loading?: boolean;
  isEdit?: boolean;
  onClose: () => void;
  onFinishHandler: (values: any) => void;
  initialValues: ISalaryTypesTableValues;
  datevNumbers: {
    _id?: string;
    company?: string;
    location?: string;
    datevNumber?: string;
  }[];
}) => {
  const { t } = useTranslation();

  return (
    <Form
      layout="vertical"
      onFinish={values => onFinishHandler(values)}
      initialValues={initialValues}
    >
      <Form.Item
        name={'salaryTypeNumber'}
        label={t('settings:salaryTypes.labels.number')}
        rules={[
          { required: true, message: t('customers:error.fieldIsRequired') },
          {
            type: 'number',
            min: 1,
            max: 8999,
            message: t('common:validation.error.mustBeBetween', {
              value: '1-8999',
            }),
          },
        ]}
      >
        <NumberInput
          allowNegative={false}
          thousandSeparator={false}
          allowLeadingZeros={false}
          placeholder="273"
          maxLength={4}
          disabled={isEdit}
        />
      </Form.Item>

      <Form.Item
        name="name"
        label={t('settings:salaryTypes.labels.name')}
        rules={[{ required: true, message: t('customers:error.fieldIsRequired') }]}
      >
        <TextInput placeholder={t('settings:salaryTypes.labels.basesalary')} disabled={isEdit} />
      </Form.Item>

      <Form.Item
        name="clientNumbers"
        label={t('settings:salaryTypes.labels.clients')}
        rules={[{ required: true, message: t('customers:error.fieldIsRequired') }]}
      >
        <ClientsSelect
          placeholder={t('settings:salaryTypes.labels.selectClientNumbers')}
          optionData={datevNumbers}
        />
      </Form.Item>

      <ButtonsWrapper marginTop={16}>
        <Button type="primary" loading={loading} htmlType="submit">
          {t('common:buttons.save')}
        </Button>
        <Button onClick={onClose}>{t('common:buttons.cancel')}</Button>
      </ButtonsWrapper>
    </Form>
  );
};

export default SalaryTypesForm;
